import script from "./FacilitySummaryView.vue?vue&type=script&setup=true&lang=js"
export * from "./FacilitySummaryView.vue?vue&type=script&setup=true&lang=js"

import "./FacilitySummaryView.vue?vue&type=style&index=0&id=5caba8f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5caba8f8"]])

export default __exports__